import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { findIndex, map } from "lodash";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Modal from "@mui/material/Modal";
import { Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import { getClassNames } from "../../Js/Common";
import Slide from '@mui/material/Slide';

const style = {
  position: "absolute",
  top: "15%",
  left: "38%",
  transform: "translate(-50%, -50%)",
  width: 300,
  "@media (min-width: 1636px)": {
    width: "28rem",
  },
  bgcolor: "#F5F7FF",
  border: "2px solid #FFFFFF",
  borderRadius: 10,
  p: 4,
};

const AutoAssignModal = (props) => {
  const containerRef = React.useRef(null);
  const [timeoutObj, setTimeoutObj] = useState(null);
  const [initialRender, setInitialRender] = useState(true);
  const [classes, setClasses] = useState([]);
  const [selectedclass, setSelectedClass] = useState(null);

  const classname = useStyles();

  // Redux state
  const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);
  let selectedClasses = useSelector(
    (state) => state.assignment.selectedClasses
  );

  useEffect(() => {
    const innerFunction = async () => {
      setClasses(await getClassNames(userInfo.site_uuid));
    };
    innerFunction();
  }, [userInfo]);

  // select class from list
  const selectClass = (obj) => {
    console.log(obj);
  };

  useEffect(() => {
    if (props.timeout && props.visible) {
      setTimeoutObj(
        setTimeout(() => {
          props.toggleModal(false);
        }, props.timeout)
      );
    }
    if (!props.visible && timeoutObj) {
      clearTimeout(timeoutObj);
    }
    if (!initialRender && !props.visible && props.onClose) {
      props.onClose();
    }
  }, [props.visible]);

  useEffect(() => {
    setInitialRender(false);
  }, []);

  return (
    <div>
      <Modal
        open={props.visible}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ border: "0px !important" }}
        ref={containerRef}
      >
        <Slide direction="up" in={props.visible} container={containerRef.current}>
        <Box
          sx={{
            ...style,
            backgroundColor: "primary.main",
            border: 0,
            borderRadius: 6,
          }}
        >
          <Grid
            container
            sx={{
              flexDirection: "row",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <Grid item sx={{ justifyContent: "center" }}>
              {/* <img src={require('../../assets/assign_color.png')} className={classname.image}></img> */}
            </Grid>
            <Grid item xs={12}>
              <Typography
                id="modal-modal-title"
                sx={{
                  color: "#FFFFFF",
                  fontSize: "1.2rem",
                  fontWeight: "800",
                  textAlign: "center",
                  "@media (min-width: 1636px)": {
                    fontSize: "2rem",
                  },
                }}
              >
                Assign to learners 
              </Typography>
            </Grid>
            <Grid item xs={12} mt={1}>
              <Typography
                id="modal-modal-title"
                sx={{
                  color: "#FFFFFF",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  textAlign: "center",
                  wordBreak: 'break-all',
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                {props.title ? props.title : ''}
              </Typography>
            </Grid>
            <Grid item xs={12} mt={1} sx={{ justifyContent: "space-around",
                  display: 'inline-flex', }}>
              <Typography
                id="modal-modal-title"
                sx={{
                  color: "#FFFFFF",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  textAlign: "center",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                From : Now
              </Typography>
              <Typography
                id="modal-modal-title"
                sx={{
                  color: "#FFFFFF",
                  fontSize: "0.9rem",
                  fontWeight: "600",
                  textAlign: "center",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                To : {props.endDate ? props.endDate : ''}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Grid item sx={{textAlign: 'center'}}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    borderRadius: 10,
                    backgroundColor: "#FFF",
                    color: "primary.main",
                    fontWeight: "bold",
                    mt: 3,
                    px: 2,
                    
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                  onClick={props.assign}
                >
                  Assign
                </Button>
              </Grid>
              <Grid item sx={{textAlign: 'center'}}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    borderRadius: 10,
                    border: 1,
                    borderColor: "#FFFFFF",
                    color: "#FFF",
                    fontWeight: "bold",
                    mt: 2,
                    px: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                  onClick={props.edit}
                >
                  Edit
                </Button>
              </Grid>
              <Grid item sx={{textAlign: 'center'}}>
                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    borderRadius: 10,
                    border: 1,
                    borderColor: "#FFFFFF",
                    color: "#FFF",
                    fontWeight: "bold",
                    mt: 2,
                    px: 2,
                    "@media (min-width: 1636px)": {
                      fontSize: "1.4rem",
                    },
                  }}
                  onClick={() => {
                    props.toggleModal(false);
                  }}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        </Slide>
      </Modal>
    </div>
  );
};
const useStyles = makeStyles({
  image: {
    width: "10rem",
    "@media (min-width: 1636px)": {
      width: "16rem",
    },
  },
});
export default AutoAssignModal;
